
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uu-dai",
      function () {
        return require("private-next-pages/uu-dai/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uu-dai"])
      });
    }
  